import { connect } from 'react-redux';

import {
  actionGetRevenueList,
  actionExportRevenueList,
} from 'store/revenue/actions';
import { actionGetAdministratorsList } from 'store/administrator/actions';
import { actionGetMarketList } from 'store/market/actions';
import {
  actionClearLandmarkList,
  actionGetLandmarkList,
} from 'store/landmark/action';

import ManagerRevenue from './ManagerRevenue';

const mapStateToProps = (state) => ({
  isLoadingRevenueList: state.Revenue.isLoadingRevenueList,
  isLoadingExportRevenueList: state.Revenue.isLoadingExportRevenueList,
  isLoadingMarketList: state.Market.isLoadingMarketList,
  isLoadingLandmarkList: state.Landmark.isLoadingLandmarkList,
  isLoadingGetAdministratorsList: state.Administrator.isLoadingGetAdministratorsList,
  revenueList: state.Revenue.revenueList,
  totalRevenue: state.Revenue.totalRevenue,
  marketList: state.Market.marketList,
  marketTotal: state.Market.marketTotal,
  landmarkOptions: state.Landmark.landmarkOptions,
  administratorsList: state.Administrator.administratorsList,
  administratorsTotal: state.Administrator.administratorsTotal,

  modalType: state.Modal.modalType,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetRevenueList: (payload) => dispatch(actionGetRevenueList(payload)),

  actionExportRevenueList: (payload) => dispatch(actionExportRevenueList(payload)),

  actionGetMarketList: (payload) => dispatch(actionGetMarketList(payload)),

  actionGetLandmarkList: (payload) => dispatch(actionGetLandmarkList(payload)),

  actionClearLandmarkList: () => dispatch(actionClearLandmarkList()),

  actionGetAdministratorsList: (payload) =>
    dispatch(actionGetAdministratorsList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerRevenue);
